export default __webpack_public_path__ + "static/media/Gaze of Others.88d6e74a.png";